/* eslint-env browser */

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'cardNumber',
    'expiration',
    'holder',
    'holderDocument'
  ]

  save () {
    const data = [
      this.cardNumberTarget.value.replace(/\D/g, ''),
      this.expirationTarget.value,
      this.holderTarget.value,
      this.holderDocumentTarget.value
    ].join('|')
    sessionStorage.setItem('_cs', btoa(data))
  }
}
